<!-- <app-header></app-header>
<section class="page-title-area pos-rel" style="background-image: url(../../../../assets/img/banner2.jpg);">
    <div class="container">
        <div class="row">
            <div class="col-xl-8 offset-xl-2">
                <div class="page-title text-center pt-180">
                    <h2>Our Projects</h2>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="three-loan-area four-loan-area five-loan-area pt-100">
    <div class="container">
        <div class="one-section-title three-section-title">
            <span class="sub-title">What We have done</span>
            <h2 id="landscapesection">Selected Projects (Only)</h2>
        </div>

        <div class="service-advisor">
            <div class="row align-items-center">
                <div class="col-lg-6">
                    <div class="advisor-img"><img
                            src="../../../assets/img/designandbuild.jpg"
                            alt="Advisor"></div>
                </div>
                <div class="col-lg-6">
                    <div class="advisor-content">
                        <h2>Design and Build</h2>
                        <div class="advisor-link"><a href="/designandbuild">VIEW
                                MORE</a><i class="bx bx-right-arrow-alt"></i></div>
                    </div>
                </div>
            </div>
        </div>

        <div class="service-advisor">
            <div class="row align-items-center">
                <div class="col-lg-6">
                    <div class="advisor-img"><img
                            src="../../../assets/img/implementation.jpg"
                            alt="Advisor"></div>
                </div>
                <div class="col-lg-6">
                    <div class="advisor-content">
                        <h2>Implementation</h2>
                        <div class="advisor-link"><a href="/implementation">VIEW MORE</a><i
                                class="bx bx-right-arrow-alt"></i></div>
                    </div>
                </div>
            </div>
        </div>

        <div class="service-advisor">
            <div class="row align-items-center">
                <div class="col-lg-6">
                    <div class="advisor-img"><img
                            src="../../../assets/img/careandmain.jpg"
                            alt="Advisor"></div>
                </div>
                <div class="col-lg-6">
                    <div class="advisor-content">
                        <h2>Care and Maintenance</h2>
                        <div class="advisor-link"><a href="/care&maintenence">VIEW MORE</a><i
                                class="bx bx-right-arrow-alt"></i></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section> 
<app-footer></app-footer>
-->

<ul>
   <li *ngFor="let product of products">
        {{product.name}} - {{product.price}}
        <button (click)="deleteProduct(product.id)">Delete</button>
        <a>Edit</a>
   </li> 
</ul>

<div class="container">
<form class="form-control" (ngSubmit)="save()">
    <label>Name:</label>
    <input [(ngModel)]="products.name" name="name"/>
    <br/>
    <label>Price</label>
    <input [(ngModel)]="products.price" name="price"/>
    <br/>
    <button type="submit">{{ isEdit ? 'update' : 'create' }} </button>
</form>

</div>